import * as React from "react"
import { Dialog, AppBar, Toolbar, IconButton, Slide, Box } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import { TransitionProps } from "@mui/material/transitions"
import DetailUser from "../DetailUser/DetailUser"

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />
})

type Props = {
  open: boolean
  onClose: () => void
  customerId: number
}

const ModalDetailUser: React.FC<Props> = ({ open, onClose, customerId }) => {
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      sx={{
        "&.MuiDialog-container": {
          backgroundColor: "black",
        },
      }}
    >
      <AppBar sx={{ position: "relative", bgcolor: "primary.main" }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 3, background: "black", height: "100vh" }}>
        <DetailUser customerId={customerId} />
      </Box>
    </Dialog>
  )
}

export default ModalDetailUser
